import { ready } from "./utils";
import updateNewsletterSubscription from "./newsletter_index";

const SUBSCRIBED_CLASS = 'newsletter-subscribed';

const onSubscriptionToggle = async (e) => {
  e.stopPropagation();

  const toggle = e.target;
  const container = toggle.closest('.newsletter-subscription-toggle-container');
  const allToggles = document.querySelectorAll('.newsletter-subscription-toggle-container');

  allToggles.forEach((toggle) =>
    toggle.querySelectorAll('button').forEach((b) => (b.disabled = true))
  );
  const isSubscribed = container.classList.contains(SUBSCRIBED_CLASS);
  const endpoint = isSubscribed
    ? container.dataset.unsubscribePath
    : container.dataset.subscribePath;
  const newsletterId = container.dataset.newsletterId;
  const response = await updateNewsletterSubscription(endpoint, newsletterId);

  if (!response.ok) {
    location.reload(); // reload the page and show a flash message
  }

  allToggles.forEach((toggle) => toggle.classList.toggle(SUBSCRIBED_CLASS));
  allToggles.forEach((toggle) =>
    toggle.querySelectorAll('button').forEach((b) => (b.disabled = false))
  );
};

ready(() => {
  const toggleButtons = document.querySelectorAll('.newsletter-subscription-toggle-button');
  if (toggleButtons.length > 0) {
    toggleButtons.forEach((elt) => elt.addEventListener('click', onSubscriptionToggle));
  }
});
